export default __webpack_public_path__ + "static/blockparty-f0fa9149372ac7c61dc41a0cd43399ba.png";